import { type Clientize, ChecklistItemInputType, type ChecklistItemView } from 'types';

const extractSearchableText = (item: Clientize<ChecklistItemView>): string => {
  const parts: string[] = [item.name, item.description];

  for (const input of item.inputs ?? []) {
    parts.push(input.label);
    for (const option of input.options ?? []) {
      parts.push(option.label);
    }
    if (input.type === ChecklistItemInputType.text) {
      const value = item.data?.[input.key];
      if (typeof value === 'string') parts.push(value);
    }
    if (input.type === ChecklistItemInputType.referenceValue && input.resolvedValue) {
      parts.push(input.resolvedValue);
    }
  }

  return parts.join(' ').toLowerCase();
};

/** Case-insensitive substring match against an item's configured content. Empty/whitespace-only
 * queries match everything. */
export const itemMatchesSearch = (item: Clientize<ChecklistItemView>, query: string): boolean => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return true;
  return extractSearchableText(item).includes(normalized);
};
